import React, { useState, useContext, useId, useRef } from "react";
import { isEmpty } from "lodash";
import { DataContext } from "../../../../context/DataContext";
import { getToken } from "../../../../api/Account";
import { updateClientReferenceAsync } from "../../../../api/Clients";
import { useAviso } from "../../../../components/base";
import { CamposReferencia, DialogoReferencia, validarReferencia } from "./DialogoReferencia";

const CambiarReferencia = ({
  selectedReference,
  setSelectedReference,
  setShowModal,
  localReload,
  setLocalReload,
}) => {
  const { id } = selectedReference;
  const inicial = {
    fullName: selectedReference.fullName,
    telefono: selectedReference.telefono,
    direccion: selectedReference.direccion,
    parentesco: selectedReference.parentesco,
  };
  const [valores, setValores] = useState(inicial);
  const [errores, setErrores] = useState({});
  // El overlay de carga no bloquea el teclado: el ref corta un segundo envío al instante.
  const enviando = useRef(false);
  const [guardando, setGuardando] = useState(false);

  const idTitulo = useId();
  const token = getToken();
  const aviso = useAviso();
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);

  const cambiar = (campo, valor) => {
    // Devuelve un entero positivo: en el teléfono solo se aceptan dígitos.
    if (campo === "telefono" && !(/^[0-9]+$/.test(valor.toString()) || valor === "")) {
      return;
    }
    setValores((actual) => ({ ...actual, [campo]: valor }));
    if (errores[campo]) setErrores({ ...errores, [campo]: undefined });
  };

  const saveChangesAsync = async () => {
    if (enviando.current) {
      return;
    }
    const faltantes = validarReferencia(valores);
    setErrores(faltantes);
    if (!isEmpty(faltantes)) {
      return;
    }

    enviando.current = true;
    setGuardando(true);
    const data = {
      id,
      fullName: valores.fullName,
      telefono: valores.telefono,
      direccion: valores.direccion,
      parentesco: valores.parentesco,
    };

    setIsLoading(true);
    let result;
    try {
      result = await updateClientReferenceAsync(token, data);
    } catch (e) {
      enviando.current = false;
      setGuardando(false);
      setIsLoading(false);
      aviso.error("No se pudo conectar con el servidor. Inténtalo de nuevo.");
      return;
    }
    enviando.current = false;
    setGuardando(false);
    if (!result.statusResponse) {
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      aviso.error(result.error || "No se pudo guardar la referencia");
      return;
    }
    setIsLoading(false);
    setSelectedReference([]);
    aviso.exito("Referencia actualizada");
    setLocalReload(!localReload);
    setShowModal(false);
  };

  return (
    <DialogoReferencia
      idTitulo={`${idTitulo}-titulo`}
      titulo="Cambiar referencia"
      textoGuardar="Guardar cambios"
      guardando={guardando}
      sucio={Object.keys(inicial).some((campo) => valores[campo] !== inicial[campo])}
      onGuardar={saveChangesAsync}
      onCerrar={() => setShowModal(false)}
    >
      <CamposReferencia
        prefijo={idTitulo}
        valores={valores}
        errores={errores}
        onCambio={cambiar}
        deshabilitado={guardando}
      />
    </DialogoReferencia>
  );
};

/**
 * Diálogo para cambiar una referencia del cliente. Se dibuja solo si `abierto`: al cerrarlo y
 * volver a abrirlo toma los datos de la referencia elegida.
 */
const EditReference = (props) => {
  if (props.abierto === false) return null;
  return <CambiarReferencia {...props} />;
};

export default EditReference;
